<ng-container [formGroup]="parentForm">
  <!-- Explicit mode: required checkbox + disclaimer with links -->
  <div *ngIf="isExplicit()" class="d-flex flex-row px-3 px-lg-1 terms">
    <app-checkbox [formControlName]="controlName"></app-checkbox>
    <div class="sticky-terms px-2 font-size-primary" [class.mb-0]="showError()">
      {{ 'public.checkout.termsAndPolicyImplicit' | translate }}
      <a
        [href]="getEffectiveTermsUrl() | safe"
        target="_blank"
        (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')"
        >{{ 'public.checkout.termsOfUse' | translate }}</a
      >,
      <a
        [href]="getEffectivePrivacyUrl() | safe"
        target="_blank"
        (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')"
        >{{ 'public.checkout.privacyPolicy' | translate }}</a
      >, {{ 'public.checkout.acceptTerms.and' | translate }}
      <a
        [href]="getEffectiveRefundUrl() | safe"
        target="_blank"
        (click)="termsPrivacyComponent.openReadMoreModal($event, 'refunds')"
        >{{ 'public.checkout.refundPolicy' | translate }}</a
      >
    </div>
  </div>

  <!-- Validation error in explicit mode -->
  <div
    *ngIf="showError()"
    class="px-2 px-lg-1 ml-2 font-size-primary mb-3 pb-1"
  >
    <span class="text-danger">{{
      'public.checkout.errorAcceptTerms' | translate
    }}</span>
  </div>

  <!-- Implicit mode: disclaimer only, no checkbox -->
  <div *ngIf="isImplicit()" class="sticky-terms px-3 px-lg-0 font-size-primary">
    {{ 'public.checkout.termsAndPolicyImplicit' | translate }}
    <a
      [href]="getEffectiveTermsUrl() | safe"
      target="_blank"
      (click)="termsPrivacyComponent.openReadMoreModal($event, 'terms')"
      >{{ 'public.checkout.termsOfUse' | translate }}</a
    >,
    <a
      [href]="getEffectivePrivacyUrl() | safe"
      target="_blank"
      (click)="termsPrivacyComponent.openReadMoreModal($event, 'policy')"
      >{{ 'public.checkout.privacyPolicy' | translate }}</a
    >, {{ 'public.checkout.acceptTerms.and' | translate }}
    <a
      [href]="getEffectiveRefundUrl() | safe"
      target="_blank"
      (click)="termsPrivacyComponent.openReadMoreModal($event, 'refunds')"
      >{{ 'public.checkout.refundPolicy' | translate }}</a
    >
  </div>
</ng-container>

<!-- Modal that the link clicks open. Self-contained so callers do not
     need to declare a separate <app-terms-privacy>. -->
<app-terms-privacy
  #termsPrivacyComponent
  [selectedStore]="selectedStore"
></app-terms-privacy>
